module.exports = __webpack_public_path__ + "img/bg-withdraw.9a3feee7.svg";